import PrivateLessonActionTypes from "./private-lessons.types";

export const setSelectedPrivateLessonAction = payload => ({
	type: PrivateLessonActionTypes.SET_SELECTED_PRIVATE_LESSON,
	payload,
});
